import { CarOutlined } from "@ant-design/icons";
import { CrudOp, projectOverviewAuthScope } from "@org-avp/avp-avengers-ui-shared-auth";
import { Translations, ViewIsAuthorized, ViewModule } from "@org-avp/avp-avengers-ui-shared-utils";
import de from "../../public/locales/de.json";
import en from "../../public/locales/en.json";
import { ProjectOverviewView } from "./lazy-view";

const translations: Translations = { de, en };
const isAuthorized: ViewIsAuthorized = (authHelperCreator) => {
  const authHelper = authHelperCreator(projectOverviewAuthScope);
  return authHelper.evaluate(CrudOp.READ);
};

export const projectOverviewViewKey = "project/project-overview";
export const projectOverviewViewModule: ViewModule = {
  viewKey: projectOverviewViewKey,
  viewEl: <ProjectOverviewView/>,
  displayNameI18nKey: "projectOverview:viewName",
  menuIconEl: <CarOutlined/>,
  isAuthorized,
  translations,
};
